import Vue from 'vue'

const resource = 'users'

const show = (id, key = null) => Vue.axios.get(`${resource}/${id}?key=${key}`)
const get = params => Vue.axios.get(`${resource}`, {params})
const getRecents = params => Vue.axios.get(`${resource}/recents`, {params})
const getCustomersInvoiceIndex = (headers = {}) => Vue.axios.get(`${resource}/invoices`, {headers})
const getEditingShippingAddressInfo = (headers = {}) => Vue.axios.get(`${resource}/addresses`, {headers})
const getEditingCardInfo = (headers = {}) => Vue.axios.get(`${resource}/card-edit`, {headers})

export default {
  get,
  getRecents,
  show,
  getCustomersInvoiceIndex,
  getEditingShippingAddressInfo,
  getEditingCardInfo
}



// WEBPACK FOOTER //
// ./src/api/users.js